import { apiClient } from '@/hooks/useAxios';
import { CommonRes } from '@/types';

const ApiPath = '/questionnaire-file';

export const uploadQuestionnaireFile = async (
  questionnaireId: string,
  questionId: string,
  file: File,
  onUploadProgress?: (progressEvent: { loaded: number; total?: number }) => void,
): Promise<CommonRes<{ objectPath: string }>> => {
  const form = new FormData();
  form.append('file', file);

  const res = await apiClient.post<CommonRes<{ objectPath: string }>>(
    `${ApiPath}/upload?questionnaireId=${questionnaireId}&questionId=${questionId}`,
    form,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
      onUploadProgress,
    },
  );
  return res.data;
};

export const getQuestionnaireFileUrl = async (
  questionnaireId: string,
  questionId: string,
  showLoading: boolean = false,
): Promise<CommonRes<{ url: string }>> => {
  const config = showLoading ? {} : { headers: { 'X-Show-Loading': 'false' } };
  const res = await apiClient.get<CommonRes<{ url: string }>>(
    `${ApiPath}/url?questionnaireId=${questionnaireId}&questionId=${questionId}`,
    config,
  );
  return res.data;
};
